import React, { Component } from "react";
import firebase from "../sdks/firebase";

import Logo from "./Logo.js";
import GetChromeExtension from "./GetChromeExtension.js";

class PageHome extends Component {
  componentWillMount() {
    // this.fetchPopularVideos();
  }

  /*
  fetchPopularVideos() {
    this.popularVideosRef = firebase
      .database()
      .ref(`videos`)
      .orderByChild("views");
    this.popularVideosRef
      .limitToLast(30)
      .once("value")
      .then(snapshot => {
        let list = [];
        snapshot.forEach(function (child) {
          console.log(child);
          list.unshift(child.val());
        });
        this.setState({ list });
      });
  }
  */

  render() {
    const params = [
      // 'autoplay=1',
      // 'loop=1',
      "controls=0",
      "showinfo=0",
      "rel=0",
    ];
    const urlIframe = `https://www.youtube.com/embed/dE-Bs8c-YOs?${params.join(
      "&"
    )}`;

    return (
      <div className="page-home">
        <div className="presentation">
          <Logo />
          <p>Share specific moments of youtube videos</p>
          <GetChromeExtension color={"white"} />
          <iframe
            width="100%"
            height="400"
            src={urlIframe}
            frameBorder="0"
            allowFullScreen={true}
          />
        </div>
      </div>
    );
  }
}

export default PageHome;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/PageHome.js
 **/